module.exports = __webpack_public_path__ + "img/yarn.0910ee08.png";